(function () {
  if (window.__staggerRevealReady) return;
  window.__staggerRevealReady = true;

  // General-purpose left-to-right stagger reveal for any multi-column
  // grid/carousel. Deliberately NOT IntersectionObserver-based: content
  // inside a Swiper carousel can have its slides positioned/clipped by
  // Swiper's own JS shortly after load, and IntersectionObserver's very
  // first check can fire before that happens - if it does, every item
  // reads as "already visible" and permanently skips its reveal. A plain
  // scroll-position check on the container isn't subject to that race.
  function checkReveal() {
    document.querySelectorAll('[data-stagger-group]:not(.is-revealed)').forEach(function (container) {
      var rect = container.getBoundingClientRect();
      if (rect.top < window.innerHeight - 50) {
        container.classList.add('is-revealed');
      }
    });
  }

  window.addEventListener('scroll', checkReveal, { passive: true });
  window.addEventListener('resize', checkReveal);
  if (document.readyState !== 'loading') checkReveal();
  else document.addEventListener('DOMContentLoaded', checkReveal);
})();
